import { render, staticRenderFns } from "./cloudwave.vue?vue&type=template&id=5bf17d5e&scoped=true"
import script from "./cloudwave.vue?vue&type=script&lang=js"
export * from "./cloudwave.vue?vue&type=script&lang=js"
import style0 from "./cloudwave.vue?vue&type=style&index=0&id=5bf17d5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf17d5e",
  null
  
)

export default component.exports